import { createAppAsyncThunk } from 'src/store/utils/thunks';
import type { RootState } from 'src/store';
import { parseMessage } from './utils';
import type { WebMessagePayload } from 'src/store/shared/tradingBots/types';
import type { sendMessageWs } from 'src/store/shared/tradingBots/actions';

import dayjs from '@skynet/formatting-date';

export const sendMessageAction = ({
  prefix,
  selectorTradingSessionDetails,
  selectorTradingLastMessageId,
  sendMessage,
}: {
  prefix: 'loans' | 'retainers' | 'trading';
  selectorTradingSessionDetails: (state: RootState) => { ID: string; session: string } | null;
  selectorTradingLastMessageId: (state: RootState) => number;
  sendMessage: typeof sendMessageWs;
}) => {
  return createAppAsyncThunk(`${prefix}/bots/sendMessage`, (data: WebMessagePayload, thunkApi) => {
    const state = thunkApi.getState();
    const sessionDetails = selectorTradingSessionDetails(state);
    if (!sessionDetails) {
      return;
    }

    const { ID, session } = sessionDetails;
    const lastMessageID = selectorTradingLastMessageId(state);
    const messageID = lastMessageID + 1;
    const { message } = data;
    thunkApi.dispatch({
      type: `${prefix}/bots/setMessage`,
      payload: {
        session,
        messageID: dayjs().unix(),
        ...parseMessage(`> ${message}`),
      },
    });

    void thunkApi.dispatch(sendMessage({ session, message, messageID, ID }));
  });
};
